/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {PossessedGameAssets} from "../PossessedGameAssets";
import {Possessed} from "../Possessed";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {gsap} from "gsap"

export class PossessedForegroundElements extends PIXI.Container implements StageLayer {
    public logo:PIXI.Sprite;
    public logoFS:PIXI.Sprite;

    private fsFireAnimation:PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "ExorcismForegroundElements";
        this.init();
    }

    private init() {
        this.fsFireAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.BACKGROUND_FIRE_ANIMATION));
        this.fsFireAnimation.position.set(360, 360);
        this.fsFireAnimation.visible = false;
        this.addChild(this.fsFireAnimation);

        this.logo = new PIXI.Sprite(ImgLoader.getImgTexture(PossessedGameAssets.IMAGES_LOGO));
        this.logo.scale.set(0.65,0.65);
        this.logo.anchor.set(0.5,0.5);
        this.logo.visible = !Possessed.model.isFreespins();
        this.addChild(this.logo);

        this.logoFS = new PIXI.Sprite(ImgLoader.getImgTexture(PossessedGameAssets.IMAGES_LOGO_FS));
        this.logoFS.scale.set(0.65,0.65);
        this.logoFS.anchor.set(0.5,0.5);
        this.logoFS.visible = Possessed.model.isFreespins();
        this.addChild(this.logoFS);

        this.onResize();
    }

    public startFsFire() {
        SpineGSAPWrapper.resetSpineState(this.fsFireAnimation);
        this.fsFireAnimation.state.setAnimation(0, "hotAir", true);
    }
    public stopFsFire() {
        this.fsFireAnimation.visible = false;
    }

    public setFreespinsLogo() {
        this.logo.visible = false;
        this.logoFS.visible = true;
    }
    public setBaseLogo() {
        this.logo.visible = true;
        this.logoFS.visible = false;
    }

    public playEasterEggLogoBlink():gsap.core.Timeline {
        const tl = gsap.timeline();
        const ease = "none";
        const blinks = 3;

        tl.add(() => {
            this.logoFS.visible = true;
            this.logoFS.alpha = 0;
        })
        tl.add(gsap.to(this.logo, {alpha: 0, duration: 0.2, ease}))
        tl.add(gsap.to(this.logoFS, {alpha: 1, duration: 0.2, ease}), "<");
        tl.add(()=>{}, ">0.82")
        tl.add(gsap.to(this.logo, {alpha: 1, duration: 0.2, ease}))
        tl.add(gsap.to(this.logoFS, {alpha: 0, duration: 0.2, ease}), "<");
        tl.repeat(blinks);
        tl.add(() => {
            this.logoFS.visible = false;
        })
        return tl;
    }

    public onResize() {
        if (NolimitApplication.isLandscape){
            this.logo.scale.set(0.8, 0.8);
            this.logo.position.set(NolimitApplication.screenBounds.left / 2 + 67, 130);
            this.logo.visible = (NolimitApplication.screenBounds.left - 134) < (-this.logo.width);

            this.logoFS.scale.set(0.8, 0.8);
            this.logoFS.position.set(NolimitApplication.screenBounds.left / 2 + 67, 130);
        } else {
            this.logo.scale.set(1,1);
            this.logo.position.set(360, NolimitApplication.screenBounds.top / 2);
            this.logo.visible = NolimitApplication.screenBounds.top < (-this.logo.height);

            this.logoFS.scale.set(1,1);
            this.logoFS.position.set(360, NolimitApplication.screenBounds.top / 2);
        }
        Possessed.easterEggView?.updateClickAreaPos();
    }
}